import React from 'react';
import { Container, Typography, Box, Card, CardContent, Button, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { blogPosts } from '../../../data/blogs';
import './Blogs.scss';

const Blogs = () => {
  return (
    <section id="blogs" className="blogs-section">
      <Container maxWidth="lg">
        <Typography variant="h2" className="section-title" gutterBottom>
          Blogs
        </Typography>
        <Box className="section-divider" />
        <Typography variant="body1" className="blogs-intro">
          Notes on building software, working with AI, and staying sharp as an engineer.
        </Typography>
        <Box className="blogs-scroll">
          {blogPosts.map((post) => (
            <Card key={post.slug} className="blog-card" elevation={2}>
              <CardContent className="blog-card-content">
                <Box className="blog-card-tags">
                  {post.tags.map((tag) => (
                    <Chip key={tag} label={tag} size="small" className="blog-tag" />
                  ))}
                </Box>
                <Typography variant="h6" component="h3" className="blog-card-title">
                  {post.title}
                </Typography>
                <Typography variant="body2" className="blog-card-excerpt" color="text.secondary">
                  {post.excerpt}
                </Typography>
                <Box className="blog-card-footer">
                  <Typography variant="caption" className="blog-read-time">
                    {post.readTime}
                  </Typography>
                  <Button
                    component={Link}
                    to={`/blog/${post.slug}`}
                    endIcon={<ArrowForwardIcon />}
                    size="small"
                    className="blog-read-more"
                  >
                    Read more
                  </Button>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </section>
  );
};

export default Blogs;
